import TransferPaymentTicket from './TransferPaymentTicketContainer';

export default TransferPaymentTicket;
